import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NavigationExtras } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { debounceTime, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-search-request',
  templateUrl: './search-request.component.html',
  styleUrls: ['./search-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
})
export class SearchRequestComponent implements OnInit {
  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {}

  @Input()
  searchRequest$: Observable<string> | null = null;

  @Input()
  searchOnChanges: boolean = true;

  @Input({ required: true })
  fc!: FormControl;

  @ViewChild('input')
  input!: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    if (this.searchOnChanges) {
      this.fc.valueChanges
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          debounceTime(300),
          tap((value: string) => {
            this.onSearch(value);
          }),
        )
        .subscribe();
    }
  }

  protected onSearch(value: string | null): void {
    if (value === null) {
      return;
    }

    const extras: NavigationExtras = {
      queryParams: value ? { search: value.trim() } : { search: null },
      queryParamsHandling: 'merge',
    };

    this.store.dispatch(new Navigate(['/gallery'], [], extras));
  }

  focus(): void {
    this.input.nativeElement.focus();
  }
}
